// extracted by mini-css-extract-plugin
export default {"root":"SettingsDialogButton_root__9ByKw"};